export const getPlatform = async () => {
  if (RUNTIME_ENV === 'native') {
    const { Device } = await import('@capacitor/device');
    const info = await Device.getInfo();
    return info.platform;
  }
  return 'browser';
};
